import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { EventBus } from '@primeuix/utils/eventbus';
import { ErrorHandler } from '@angular/core';
import { SentryErrorHandler } from './app/components/sentry/sentry-error-handler.component';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import Preset from './preset';
import { MessageService, ConfirmationService } from 'primeng/api';
import { httpInterceptorProviders } from './app/interceptors/interceptor.module';
import { GraphQLModule } from './app/modules/graphql.module';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { Routes } from '@angular/router';
import { HomeComponent } from './app/components/home/home.component';
import { LoginComponent } from './app/components/login/login.component';
import { CheckComponent } from './app/components/register/check/check.component';
import { SearchComponent } from './app/components/products/search/search.component';
import { ProductShareComponent } from './app/components/product-share/product-share.component';
import { RegisterComponent } from './app/components/product-share/register/register.component';
import { StoreComponent } from './app/components/product-share/store/store.component';
import { AmazonPriceTrackingComponent } from './app/components/amazon-price-tracking/amazon-price-tracking.component';
import { AmazonTrackingComponent } from './app/components/amazon-tracking/amazon-tracking.component';
import { AmazonTrackingRegisterComponent } from './app/components/amazon-tracking/register/register.component';
import { BiccameraComponent } from './app/components/biccamera/biccamera.component';
import { ChangelogComponent } from './app/components/changelog/changelog.component';
import { IrisComponent } from './app/components/iris/iris.component';
import { CallbackComponent } from './app/components/oauth/callback/callback.component';
import { KojimaComponent } from './app/components/kojima/kojima.component';
import { YamadaComponent } from './app/components/yamada/yamada.component';
import { EdionComponent } from './app/components/edion/edion.component';
import { DonkiComponent } from './app/components/donki/donki.component';
import { DiscontinueComponent } from './app/components/discontinue/discontinue.component';
import { AmazonNoficationComponent } from './app/components/amazon-notification/amazon-notification.component';
import { AmazonNotificationRegisterComponent } from './app/components/amazon-notification/register/register.component';
import { AmazonNotificationListComponent } from './app/components/amazon-notification/list/list.component';
import { OpenCloseComponent } from './app/components/open-close/open-close.component';
import { AeonComponent } from './app/components/aeon/aeon.component';
import { AdminUserComponent } from './app/components/admin-user/admin-user.component';
import { KeepaComponent } from './app/components/keepa/keepa.component';
import { pendingRequestsInterceptor$ } from 'ng-http-loader';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register/:token', component: CheckComponent },
  { path: 'products/search', component: SearchComponent },
  { path: 'share', component: ProductShareComponent },
  { path: 'share/register', component: RegisterComponent },
  { path: 'share/store', component: StoreComponent },
  { path: 'amazon-notification', component: AmazonNoficationComponent },
  { path: 'amazon-notification/register', component: AmazonNotificationRegisterComponent },
  { path: 'amazon-notification/list', component: AmazonNotificationListComponent },
  { path: 'amazon-price-tracking', component: AmazonPriceTrackingComponent },
  { path: 'amazon-tracking', component: AmazonTrackingComponent },
  { path: 'amazon-tracking/register', component: AmazonTrackingRegisterComponent },
  { path: 'biccamera', component: BiccameraComponent },
  { path: 'kojima', component: KojimaComponent },
  { path: 'changelog', component: ChangelogComponent },
  { path: 'iris', component: IrisComponent },
  { path: 'yamada', component: YamadaComponent },
  { path: 'edion', component: EdionComponent },
  { path: 'donki', component: DonkiComponent },
  { path: 'discontinue', component: DiscontinueComponent },
  { path: 'oauth/callback', component: CallbackComponent },
  { path: 'open-close', component: OpenCloseComponent },
  { path: 'aeon', component: AeonComponent },
  { path: 'admin-user', component: AdminUserComponent },
  { path: 'keepa', component: KeepaComponent },
];

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    // AuthInterceptor は httpInterceptorProviders（HTTP_INTERCEPTORS）で登録しているので withInterceptorsFromDi が要る
    provideHttpClient(withXhr(), withInterceptors([pendingRequestsInterceptor$]), withInterceptorsFromDi()),
    httpInterceptorProviders,
    ConfirmationService,
    MessageService,
    { provide: 'EVENT_BUS', useFactory: () => EventBus() },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    providePrimeNG({
      // PrimeUI Community ライセンス（照合はオフラインなのでバンドルに入る前提の値）。
      // 期限 2027-10-24、30 日の猶予を過ぎると画面に「Invalid PrimeUI License」が出る。primeui.store で無料更新して差し替える
      license:
        'eyJpZCI6ImFlZWQwNGE5LTNjNzUtNDcyNi1iYjY4LTBjM2IzNDkwMTJkNCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3OTI4MDc4OTcsImV4cCI6MTgyNDM0Mzg5N30.ESDSAONNIyx9ah9ZFAZwIOE410a_7FnPDbJhnZ3xtyqRKHZs9zZu2Zs5-QJ1GEAJOSf4qJBAoEjwD5LCIVTtDg',
      theme: {
        preset: Preset,
      },
    }),
    importProvidersFrom(GraphQLModule),
  ],
}).catch((err) => console.error(err));
